module.exports = __webpack_public_path__ + "img/inovátor_nové_generace.5e3478b5.png";